/* eslint-disable no-unused-vars */
import React from 'react';
import { PageWrapStyles } from './pagewrapstyles';

import Header from '../header/header';
import Content from '../content/content';
import Footer from '../footer/footer';

export default function PageWrap() {
  return (
    <PageWrapStyles>
      <Header />
      <Content />
      <Footer />
    </PageWrapStyles>
  );
}
